import React, { forwardRef } from 'react';
import * as S from './Filter.styles';
export const Filter = forwardRef((props, ref) => React.createElement(S.Filter, Object.assign({
  "data-ds-component": "DS-Select-Input",
  ref: ref,
  role: "combobox",
  "aria-autocomplete": "list",
  type: "text",
  autoComplete: "off"
}, props)));
Filter.displayName = 'Filter';